import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOpportunityMSServiceDocument } from '~/types/document/models'

export const {
  getDocumentListData: getOpportunityMSServiceDocumentListData,
  getDocumentDataById: getOpportunityMSServiceDocumentDataById,
  getDocumentListDataByParentId:
    getOpportunityMSServiceDocumentListDataByOMSSId,
} = makeDocumentMockData<IOpportunityMSServiceDocument>({
  entityName: 'opportunityMSService',
  storageKeyPrefix: 'opportunitymsservice',
})
